'use strict';

var cache = {};
var util = require('../util/util');
let _ = require('lodash');

var popoverTriggerType = util.isTouchDevice() ? 'click' : 'click hover';

function popoverBaseTemplate(wrapperClass) {
    return '<div class="popover bbw-popover ' + wrapperClass + '" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
}

function initUserPopoverEvents(trigger, template) {
    trigger.on('focusin mouseenter', function () {
        var $this = $(this);

        $this.popover('show');
        template.on('mouseleave', function () {
            $this.popover('hide');
        });
    }).on('mouseleave', function () {
        var $this = $(this);
        setTimeout(function () {
            if (!$('.popover:hover').length) {
                $this.popover('hide');
            }
        }, 400);
    });
}

module.exports = {
    initPopoverCache: function () {
        cache.$document = $(document);
        cache.$popover = $('.js-popover');

        //Footer Subscribe popover
        cache.$footerPopoverTrigger = $('.js-bbw-footer-popover-trigger');
        cache.footerPopoverTemplate = $('.js-bbw-footer-popover-template').length > 0 ? $('.js-bbw-footer-popover-template') : '';

        // Account Not Logged popover
        cache.$accountPopoverTrigger = $('.js-account-popover-trigger');
        cache.accountPopoverTemplate = $('.js-bbw-account-popover-template').length > 0 ? $('.js-bbw-account-popover-template') : '';

        cache.$accountPopverContainer = $('.js-account-popover-container');

        // Account Logged popover
        cache.$accountLoggedPopoverTrigger = $('.js-account-popover-logged-trigger');
        cache.accountLoggedPopoverTemplate = $('.js-bbw-account-logged-popover-template').length > 0 ? $('.js-bbw-account-logged-popover-template') : '';

        //Gift Cards Landing Page Check Balance PIN popover
        cache.$giftCardPinPopoverTrigger = $('.js-bbw-giftcard-pin-popover-trigger');
        cache.giftCardPinTemplate = $('.js-bbw-giftcard-pin-popover-template').length > 0 ? $('.js-bbw-giftcard-pin-popover-template') : '';

        //Register Form popover
        cache.$registerPopoverTrigger = $('.js-bbw-register-popover-trigger');
        cache.registerPopoverTemplate = $('.js-bbw-register-popover-template').length > 0 ? $('.js-bbw-register-popover-template') : '';

        //Checkout email popover
        cache.$checkoutEmailPopoverTrigger = $('.js-bbw-checkout-email-popover-trigger');
        cache.emailPopoverTemplate = $('.js-bbw-email-popover-template').length > 0 ? $('.js-bbw-email-popover-template') : '';

        //Checkout phone popover
        cache.$checkoutPhonePopoverTrigger = $('.js-bbw-checkout-phone-popover-trigger');
        cache.phonePopoverTemplate = $('.js-bbw-phone-popover-template').length > 0 ? $('.js-bbw-phone-popover-template') : '';

        //Checkout GC Pin popover
        cache.$checkoutGCPopoverTrigger = $('.js-bbw-checkout-gc-popover-trigger');
        cache.gcPinPopoverTemplate = $('.js-bbw-gc-pin-popover-template').length > 0 ? $('.js-bbw-gc-pin-popover-template') : '';
    },
    accesibilityFixes: function () {
        cache.$document.on('keyup', '.js-bbw-footer-popover-close-button, .js-bbw-register-popover-close-button', function (event) {
            if (event.which == 13) {
                var $this = $(this);

                $this.trigger('click');
                $this.closest('.form-group').find('.js-popover').focus();
            }
        });
        cache.$document.on('keyup', '.shipping-method-option', function (event) {
            if (event.which == 13) {
                var $this = $(this);
                $this.closest('.bbw-radio-wrapper').find('.bbw-radio-input').click();
            }
        });
        cache.$document.on('keyup', '*[data-toggle="popover"], *[data-toggle="tooltip"]', function (event) {
            var $this = $(this);
            if (event.which == 13) {
                $this.trigger('click');
            }
            if (event.which == 27) {
                $('#' + $this.attr('aria-describedby')).popover('hide');
            }
        });

        cache.$accountPopoverTrigger.on('show.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', true).find('a').attr('aria-expanded', true);
        });
        cache.$accountLoggedPopoverTrigger.on('show.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', true).find('a').attr('aria-expanded', true);
        });
        cache.$accountPopoverTrigger.on('hide.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', false).find('a').attr('aria-expanded', false);
        });
        cache.$accountLoggedPopoverTrigger.on('hide.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', false).find('a').attr('aria-expanded', false);
        });
        cache.$footerPopoverTrigger.on('show.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', true);
        });
        cache.$footerPopoverTrigger.on('hide.bs.popover', function () {
            var $this = $(this);
            $this.attr('aria-expanded', false);
        });
    },
    closePopoverOnClickOutside: function () {
        cache.$document.on('click', function (e) {
            $('[data-toggle="popover"],[data-original-title]').each(function () {
                var $this = $(this);
                // the 'is' for buttons that trigger popups
                // the 'has' for icons within a button that triggers a popup
                if (!$this.is(e.target) && $this.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    (($this.popover('hide').data('bs.popover')||{}).inState||{}).click = false; // fix for BS 3.3.6
                }
            });
        });
    },
    initFooterPopover: function () {
        this.initPopoverCache();

        cache.$footerPopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'right',
            template: popoverBaseTemplate('bbw-footer-popover'),
            content: cache.footerPopoverTemplate,
            html: true
        });

        cache.$document.on('click', '.js-bbw-footer-popover-close-button', function () {
            cache.$footerPopoverTrigger.popover('hide');
        });
    },
    initAccountPopover: function () {
        this.initPopoverCache();

        var popoverTrigger = cache.$accountPopoverTrigger;
        var popoverTemplate = cache.accountPopoverTemplate;
        var apGeneralOptions = {
            placement: 'bottom',
            template: popoverBaseTemplate('bbw-account-popover'),
            offset: '-100px 0',
            content: popoverTemplate,
            container: cache.$accountPopverContainer,
            html: true
        };

        if (util.isTouchDevice()) {
            popoverTrigger.popover(_.extend(apGeneralOptions, {
                trigger: 'click'
            }));
        } else {
            popoverTrigger.popover(_.extend(apGeneralOptions, {
                trigger: 'manual'
            }));

            initUserPopoverEvents(popoverTrigger, popoverTemplate);
        }
    },
    initAccountLoggedPopover: function () {
        this.initPopoverCache();

        var popoverTrigger = cache.$accountLoggedPopoverTrigger;
        var popoverTemplate = cache.accountLoggedPopoverTemplate;

        popoverTrigger.popover({
            trigger: util.isTouchDevice() ? 'click': 'manual',
            placement: 'bottom',
            template: popoverBaseTemplate('bbw-account-logged-popover bbw-account-popover'),
            offset: '-80% 0',
            content: popoverTemplate,
            container: cache.$accountPopverContainer,
            html: true
        });

        initUserPopoverEvents(popoverTrigger, popoverTemplate);
    },
    initGiftCardPinPopover: function () {
        this.initPopoverCache();

        cache.$giftCardPinPopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'right',
            template: popoverBaseTemplate('bbw-giftcard-pin-popover'),
            content: cache.giftCardPinTemplate,
            html: true
        });

        cache.$document.on('click', '.js-bbw-giftcard-pin-popover-close-button', function () {
            cache.$giftCardPinPopoverTrigger.popover('hide');
        });
    },
    initLoginPopover: function () {
        this.initPopoverCache();

        cache.$registerPopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'right',
            template: popoverBaseTemplate('bbw-register-popover'),
            content: cache.registerPopoverTemplate,
            html: true
        });

        cache.$document.on('click', '.js-bbw-register-popover-close-button', function () {
            cache.$registerPopoverTrigger.popover('hide');
        });
    },
    initCheckoutEmailPopover: function () {
        this.initPopoverCache();

        cache.$checkoutEmailPopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'top',
            template: popoverBaseTemplate('bbw-footer-popover'),
            content: cache.emailPopoverTemplate,
            html: true
        });

        cache.$document.on('click', '.js-bbw-checkout-popover-close-button', function () {
            cache.$checkoutEmailPopoverTrigger.popover('hide');
        });
    },
    initCheckoutPhonePopover: function () {
        this.initPopoverCache();

        cache.$checkoutPhonePopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'top',
            template: popoverBaseTemplate('bbw-footer-popover'),
            content: cache.phonePopoverTemplate,
            html: true
        });
    },
    initCheckoutGCPinPopover: function () {
        this.initPopoverCache();

        cache.$checkoutGCPopoverTrigger.popover({
            trigger: popoverTriggerType,
            placement: 'top',
            template: popoverBaseTemplate('bbw-footer-popover'),
            content: cache.gcPinPopoverTemplate,
            html: true
        });

        cache.$document.on('click', '.js-bbw-checkout-popover-close-button', function () {
            cache.$checkoutGCPopoverTrigger.popover('hide');
        });
    }
};
